import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function UnsupportedCard({ answer }: Props) {
  const label = answer.kind === 'deep_corpus_limitation' ? 'Evidence gate' : 'Not yet supported';

  return (
    <article className="rounded-lg border border-slate-300 bg-slate-50 p-4 text-sm text-slate-800">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-slate-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-700">
          {label}
        </span>
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
